import { SharedAvalPartnerKonfiguratorService } from '@/shared/api/services/avalpartnerkonfigurator/avalpartnerkonfigurator';
import type { GevoDaten } from '@/shared/AvalKonfigurator/Kommunikation';

export class Avalpartnerkonfigurator extends SharedAvalPartnerKonfiguratorService {
  async ermittelGevoDatenFuerBuergen(): Promise<GevoDaten> {
    return this.httpClient.get(`${this.avalPartnerKonfiguratorServiceBaseUrl}/buerge/gevo`);
  }
}
